import axios from 'axios';
import {toast} from "react-toastify";

class BaseService {
    constructor(baseURL, additionalConfig = {}) {
        this.axiosInstance = axios.create({
            baseURL: baseURL,
            ...additionalConfig, // Allows additional Axios configurations
        });
        this.axiosInstance.interceptors.response.use(
            response => {
                return response;
                // let method = response.config.method
                // if (['post', 'patch', 'put'].includes(method)) {
                //     let message = `Request successfully executed. Status: ${response.status}, Path: ${response.config.baseURL}, Method: ${method}`;
                //     toast.success(message);
                // }
                // return response
            },
            error => {
                if (error.response && error.response.data) {
                    var err = error.response.data;
                    var message = err.fieldErrors ? err.fieldErrors.map(fieldError => JSON.stringify(fieldError, null, 2))
                        .join() : err.exceptionMessages ? err.exceptionMessages : err.message;
                    toast.error('Something went wrong,' + message);
                    return Promise.reject(error.response.data);
                }
                toast.error("Unknown error: " + error.response.data);
                return Promise.reject({message: "Unknown error", code: "ERR_UNKNOWN"});
            }
        );
        // this.axiosInstance.interceptors.request.use(request => {
        //     console.log('Request:', request);
        //     return request;
        // });
    }

    get(url, params, config) {
        return this.axiosInstance.get(url, {...config, params: params});
    }

    post(url, data, config) {
        return this.axiosInstance.post(url, data, config);
    }

    put(url, data, config) {
        return this.axiosInstance.put(url, data, config);
    }

    patch(url, data, config) {
        return this.axiosInstance.patch(url, data, config);
    }

    delete(url, config = {}) {
        return this.axiosInstance.delete(url, config);
    }
}

export default BaseService;
